import PageContainer from "components/Page/Container";
import PageDialogScreen from "components/Page/DialogScreen";

export default function App() {
  return (
    <PageDialogScreen>
      <PageContainer>
        <p className="text-xl font-medium text-center">
          Sorry, this site is temporarily unavailable.
        </p>
      </PageContainer>
    </PageDialogScreen>
  );
}
